import { render, staticRenderFns } from "./SupplierRawMaterialSupportingDocumentation.vue?vue&type=template&id=35af92a7&scoped=true&"
import script from "./SupplierRawMaterialSupportingDocumentation.vue?vue&type=script&lang=js&"
export * from "./SupplierRawMaterialSupportingDocumentation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35af92a7",
  null
  
)

export default component.exports